import React from 'react'
import aboutImg from '../../assets/aboutImg.png'
export default function AboutBanner() {
  return (
    <>
    {/* HERO SECTION */}
    <div className="relative py-20 bg-gradient-to-r from-trogoBlue to-trogoOrange py-24 text-white overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>

        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-h1 md:text-5xl font-extrabold">
            About Us
          </h1>
          <p className="mt-4 text-body text-white/90 max-w-3xl mx-auto">
            Everything you need to know about TROGO’s transport and logistics platform.
          </p>
        </div>
      </div>
      <section className="relative bg-trogoBg pt-10 mt-10 pb-10">
        <div className="relative max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-h1 md:text-5xl font-extrabold leading-tight text-trogoBlue">
              About <span className="text-trogoOrange">TROGO</span>
            </h1>
            <p className="mt-6 text-body text-trogoGray leading-relaxed">
              TROGO is a next-generation transport and logistics platform built
              to simplify how people travel and how businesses move goods.
              From passenger rides to heavy vehicles and emergency transport —
              we connect you with trusted transport partners in minutes.
            </p>
          </div>

          <div className="flex justify-center">
            <img
              src={aboutImg}
              alt="About TROGO"
              className="w-96 drop-shadow-2xl rounded-xl"
            />
          </div>
        </div>
      </section>
  </>
  )
}
